<template>
  <div ref="container">
    <transition-group name="gmf-input-list" tag="div">
      <div v-for="(entry, index) in list" :key="entry.key" class="gmf-input-list-item">
        <div class="gmf-text-input">
          <TextInput :modelValue="entry.val" @update:modelValue="ev => updateValue(index, ev)" :placeholder="placeholder" @keydown.enter="ev => onEnter(ev, index)" @blur="removeIfEmpty(entry)" :maxlength="maxItemLength"></TextInput>
        </div>
        <div class="gmf-input-list-remove" v-if="index < list.length - 1 || entry.val.length > 0" @click="remove(entry)">✕</div>
      </div>
    </transition-group>
  </div>
</template>

<style>
.gmf-input-list-item {
  position: relative;
}
.gmf-input-list-item:not(:last-child) {
  margin-bottom: 12px;
}
.gmf-input-list-remove {
  display: block;
  background: var(--gmf-col-gray);
  top: 9px;
  right: 9px;
  position: absolute;
  border-radius: 100%;
  text-align: center;
  height: 22px;
  width: 22px;
  line-height: 22px !important;
  color: var(--gmf-col-lightgray)  !important;
  font-weight: bold  !important;
  font-size: 15px  !important;
  cursor: pointer;
}
.gmf-input-list-remove:hover {
  background: var(--gmf-col-error);
  color: #fff;
}


.gmf-input-list-enter-active,
.gmf-input-list-leave-active {
  transition: all 0.2s ease-out;
}
.gmf-input-list-enter-from,
.gmf-input-list-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>

<script>
import TextInput from '@/components/input/TextInput.vue';

export default {
    props: ["modelValue", "placeholder", "maxItems", "maxItemLength"],
    data() {
        let nextKey = 0;
        let list = [];
        if (this.modelValue) {
            for (const val of this.modelValue) {
                list.push({
                    key: nextKey++,
                    val,
                });
            }
        }
        if (list.length === 0 || list[list.length - 1].val.length > 0) {
            if (!this.maxItems || list.length < this.maxItems) {
                list.push({
                    key: nextKey++,
                    val: "",
                });
            }
        }
        return {
            nextKey,
            list,
        };
    },
    methods: {
        emit() {
            this.$emit("update:modelValue", this.list.map(r => r.val).filter(v => v.length > 0));
        },
        onEnter(ev, index) {
            ev.preventDefault();
            ev.stopPropagation();
            let it = this.list[index];
            if (it.val.length > 0) { // focus next item
                let items = this.$refs.container.querySelectorAll("input");
                for (let i = index + 1; i < items.length; ++i) {
                    if (this.list[i].val.length === 0) {
                        items[i].focus();
                        break;
                    }
                }
            }
            return false;
        },
        updateValue(index, value) {
            if (this.maxItemLength && value.length > this.maxItemLength) {
                value = value.slice(0, this.maxItemLength);
            }
            this.list[index].val = value;
            if (index >= this.list.length - 1) {
                if (!this.maxItems || this.list.length < this.maxItems) {
                    this.list.push({
                        key: this.nextKey++,
                        val: "",
                    });
                }
            }
            this.emit();
        },
        remove(entry) {
            let index = this.list.indexOf(entry);
            if (index < 0) {
                return;
            }
            if (index === this.list.length - 1) {
                entry.val = "";
            }
            else {
                this.list.splice(index, 1);
                if (this.list.length === 0 || this.list[this.list.length - 1].val.length > 0) {
                    this.list.push({
                        key: this.nextKey++,
                        val: "",
                    });
                }
            }
            this.emit();
        },
        removeIfEmpty(entry) {
            let index = this.list.indexOf(entry);
            if (index < 0) {
                return;
            }
            if (entry.val.length === 0 && index < this.list.length - 1) {
                this.list.splice(index, 1);
                if (this.list.length === 0 || this.list[this.list.length - 1].val.length > 0) {
                    this.list.push({
                        key: this.nextKey++,
                        val: "",
                    });
                }
            }
        },
    },
    components: { TextInput }
};
</script>
